import React, { useState } from 'react';
import { Button } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { WHEN_TO_MOVE_CRM, WHEN_TO_MOVE_POINTS } from '../content/landingContent';

const ReadinessRail: React.FC = () => {
  const [checked, setChecked] = useState<Set<string>>(() => new Set());
  const total = WHEN_TO_MOVE_POINTS.length;
  const count = checked.size;

  function toggle(id: string) {
    setChecked((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  }

  const meterMessage =
    count === 0
      ? 'Check any that sound like your team.'
      : count >= total
        ? "That's the list. You're ready for one workspace."
        : `${count} of ${total} — you're not alone.`;

  return (
    <aside
      id="when-crm"
      className="cp-landing-readiness-rail"
      aria-labelledby="readiness-rail-title"
    >
      <div className="cp-landing-container cp-landing-readiness-rail__inner">
        <div className="cp-landing-readiness-rail__hook">
          <span className="cp-landing-readiness-rail__eyebrow">{WHEN_TO_MOVE_CRM.eyebrow}</span>
          <h2 id="readiness-rail-title" className="cp-landing-readiness-rail__title">
            {WHEN_TO_MOVE_CRM.title}
          </h2>
          <p className="cp-landing-readiness-rail__lead">{WHEN_TO_MOVE_CRM.lead}</p>
          <p className="cp-landing-readiness-rail__meter" aria-live="polite">
            {meterMessage}
          </p>
          <div className="cp-landing-readiness-rail__meter-bar" aria-hidden>
            <span
              className="cp-landing-readiness-rail__meter-fill"
              style={{ width: `${(count / total) * 100}%` }}
            />
          </div>
          {count >= 2 ? (
            <Link to="/signup" className="cp-landing-readiness-rail__cta">
              <Button type="primary" icon={<ArrowRightOutlined />}>
                Request access
              </Button>
            </Link>
          ) : null}
        </div>

        <ul className="cp-landing-readiness-rail__checks">
          {WHEN_TO_MOVE_POINTS.map((point) => {
            const isOn = checked.has(point.id);
            return (
              <li key={point.id}>
                <label className={`cp-landing-readiness-check${isOn ? ' cp-landing-readiness-check--on' : ''}`}>
                  <input
                    type="checkbox"
                    className="cp-landing-readiness-check__input"
                    checked={isOn}
                    onChange={() => toggle(point.id)}
                  />
                  <span className="cp-landing-readiness-check__box" aria-hidden />
                  <span className="cp-landing-readiness-check__text">
                    <strong>{point.headline}</strong>
                    <span className="cp-landing-readiness-check__sep"> — </span>
                    {point.detail}
                  </span>
                </label>
              </li>
            );
          })}
        </ul>
      </div>
    </aside>
  );
};

export default ReadinessRail;
